import { render, staticRenderFns } from "./Ship.vue?vue&type=template&id=e2935022&scoped=true&"
import script from "./Ship.vue?vue&type=script&lang=ts&"
export * from "./Ship.vue?vue&type=script&lang=ts&"
import style0 from "./Ship.vue?vue&type=style&index=0&id=e2935022&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2935022",
  null
  
)

export default component.exports